import { render, staticRenderFns } from "./BlackListSelection.vue?vue&type=template&id=29af4b02&"
import script from "./BlackListSelection.vue?vue&type=script&lang=ts&"
export * from "./BlackListSelection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports